import styled from 'styled-components';

import { ReactionProps } from '../types';

const StyledReactionWithCode = styled.span<{ containerHeight?: ReactionProps['containerHeight'] }>`
  font-size: medium;
  position: absolute;
  left: 3rem;
  top: ${({ containerHeight }) => (containerHeight && containerHeight > 80 ? '3rem' : '2rem')};
`;

const Reaction = ({ reactionCode, containerHeight }: ReactionProps) => {
  switch (reactionCode) {
    case 'heart':
      return (
        <StyledReactionWithCode containerHeight={containerHeight} role="button">
          &#10084;&#65039;
        </StyledReactionWithCode>
      );
    case 'face_with_open_mouth':
      return (
        <StyledReactionWithCode containerHeight={containerHeight} role="button">
          &#128558;
        </StyledReactionWithCode>
      );
    case 'fire':
      return (
        <StyledReactionWithCode containerHeight={containerHeight} role="button">
          &#128293;
        </StyledReactionWithCode>
      );
    case 'heart_eyes':
      return (
        <StyledReactionWithCode containerHeight={containerHeight} role="button">
          &#128525;
        </StyledReactionWithCode>
      );
    case 'thinking_face':
      return (
        <StyledReactionWithCode containerHeight={containerHeight} role="button">
          &#129300;
        </StyledReactionWithCode>
      );
    case 'thumbs_up':
      return (
        <StyledReactionWithCode containerHeight={containerHeight} role="button">
          &#128077;
        </StyledReactionWithCode>
      );
    default:
      return null;
  }
};

export default Reaction;
